import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MenuItem } from 'primeng/api';

import { PAGE_TOKENS, TARGET_TOKENS } from './suburbs/template/suburb-template';

/**
 * "Insert placeholder" (#262): a small menu beside a heading, eyebrow, link or button field of a suburb page template
 * or an inserted block. It only says which placeholder was picked; the field's owner puts it in at the caret. Beside
 * a link's target (`forTarget`) it offers the region page's address only: no other placeholder is an address.
 */
@Component({
  selector: 'app-placeholder-menu',
  template: `
    <button
      pButton
      type="button"
      icon="pi pi-code"
      class="p-button-text p-button-sm placeholder-menu"
      aria-label="Insert placeholder"
      pTooltip="Insert placeholder"
      tooltipPosition="top"
      (click)="menu.toggle($event)"
    ></button>
    <p-menu #menu [popup]="true" [model]="items" appendTo="body" [baseZIndex]="12000"></p-menu>
  `,
  styles: [':host { display: inline-flex; flex: 0 0 auto; align-items: center; }'],
})
export class PlaceholderMenuComponent implements OnInit {
  @Input() forTarget = false;
  @Output() pick = new EventEmitter<string>();

  items: MenuItem[] = [];

  ngOnInit(): void {
    this.items = (this.forTarget ? TARGET_TOKENS : PAGE_TOKENS).map((t) => ({
      label: `${t.label}: ${t.example}`,
      title: t.token,
      command: () => this.pick.emit(t.token),
    }));
  }
}
